import styled from 'styled-components';
import { Link as LinkOriginal } from 'react-router-dom';
import { fontTitle } from 'Styles/fonts';
import ButtonIconOriginal from '../../../Icons/ButtonIcon';

export const Link = styled(LinkOriginal)`
  margin: 16px 0 48px 0;
  text-decoration: none;
`;

export const ButtonIcon = styled(ButtonIconOriginal)`
  ${fontTitle(16)};
`;
